import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Checkbox } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import DropDownOA from '../../common/dropDownOA'
import LineInputV3 from '../../common/lineInputV3'
import { ValidateAadhaar, calculateFinalAmounts, cellStyles, excelCellStyles, headCellStyles, pancardValidation, paymentTypeStyles, getTableFilterLabels, rankFilteredRows } from './const'
import { focusElemnt, getInt, getPaymentTypeBackground, isValueinObjectArray, updateObjectInArray } from '../../common/helper'
import { SAINI_TRAVELS, SAMAY_TRAVEL, TULSI_TRAVEL, LALA_EXPRESS, GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { getColumnDefsOne } from './DeliveryMemoTableDefs'
import { useTranslation } from '../../../i18n/I18nProvider'
import { accessNameV2 } from '../BrnchUsrMaster/constants'
import { useAtomValue } from 'jotai'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'

const DeliveryMemoTable = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const tablefilterLabel1 = getTableFilterLabels(translations, 1)
  const tablefilterLabel2 = getTableFilterLabels(translations, 2)
  const columnDefsOne = getColumnDefsOne(translations)
  const { tableData, selectedTab, data, methods, selectedLRs } = props
  const { selectedLrs, loginData, showMore, setexcelData } = data
  const { setSelectedLrs, setTableData, setCheckboxStates } = methods
  const theme = useTheme()
  const { palette: cs } = theme
  const [filterValues, setFilterValues] = useState({})
  const [filteredData, setfilteredData] = useState(tableData)
  const headerRef = useRef(null);
  const totalRowRef = useRef(null);
  const selectAllRef = useRef(null);
  const [grandTotal, setGrandTotal] = useState([])
  const isSamayOrTulsiTravel = loginData?.intCompanyID === TULSI_TRAVEL || loginData?.intCompanyID === SAMAY_TRAVEL;
  const isCompanyTwelve = loginData?.intCompanyID === SAINI_TRAVELS;
  const isGujaratCompany = loginData?.intCompanyID === GUJRAT_COMPANY_ID;
  const showSenderColumns = [LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL].includes(loginData?.intCompanyID);
  const shouldHideDeliveryChargeColumns = isSamayOrTulsiTravel || isCompanyTwelve;
  const shouldHideDeliveryGstColumn = isCompanyTwelve || showSenderColumns;
  const columnShowIfCtx = { isCompanyTwelve, shouldHideDeliveryChargeColumns, shouldHideDeliveryGstColumn, isGujaratCompany, showSenderColumns }
  const visibleColumnDefsOne = columnDefsOne.filter((col) => !col.showIf || col.showIf(columnShowIfCtx))
  const getColWidth = (col) => (isGujaratCompany && col.gtWidth ? col.gtWidth : col.width)
  const consTypeFilter = { name: dm.consType || 'Cons. Type', id: 'DescriptionDet' }
  const companyTablefilterLabel1 = useMemo(() => {
    const senderFilter = [{ name: dm.senderName || 'Sender Name', id: 'Sender', marginB: true }, { name: dm.senderNoDot || 'Sender No.', id: 'SenderMobileNo' }]
    const insertBeforeReceiver = (labels) => {
      const recIndex = labels.findIndex((group) =>
        Array.isArray(group) ? group.some((f) => f.id === 'RecName') : group.id === 'RecName'
      )
      if (recIndex < 0) return labels
      return [...labels.slice(0, recIndex), senderFilter, ...labels.slice(recIndex)]
    }
    if (isCompanyTwelve) {
      return [
        ...tablefilterLabel1.slice(0, 4),
        senderFilter,
        ...tablefilterLabel1.slice(4, 6),
        { name: dm.consignment || 'Consignment', id: 'Consignment' },
        ...tablefilterLabel1.slice(6),
      ]
    }
    let labels = tablefilterLabel1
    if (isGujaratCompany) {
      labels = [...tablefilterLabel1.slice(0, 2), consTypeFilter, ...tablefilterLabel1.slice(2)]
    }
    if (showSenderColumns) {
      return insertBeforeReceiver(labels)
    }
    return labels
  }, [isCompanyTwelve, isGujaratCompany, showSenderColumns])
  const companyTablefilterLabel2 = useMemo(() => {
    const senderFilters = [
      { name: dm.senderName || 'Sender Name', id: 'Sender', marginB: true },
      { name: dm.senderNoDot || 'Sender No.', id: 'SenderMobileNo' },
    ]
    const insertBeforeReceiver = (labels) => {
      const recIndex = labels.findIndex((group) => group.id === 'RecName')
      if (recIndex < 0) return labels
      return [...labels.slice(0, recIndex), ...senderFilters, ...labels.slice(recIndex)]
    }
    if (isCompanyTwelve) {
      return [
        ...tablefilterLabel2.slice(0, 8),
        { name: dm.senderName || 'Sender Name', id: 'Sender', marginB: true },
        { name: dm.senderNoDot || 'Sender No.', id: 'SenderMobileNo' },
        ...tablefilterLabel2.slice(8, 12),
        { name: dm.consignment || 'Consignment', id: 'Consignment' },
        ...tablefilterLabel2.slice(12),
      ]
    }
    let labels = tablefilterLabel2
    if (isGujaratCompany) {
      labels = [...tablefilterLabel2.slice(0, 3), consTypeFilter, ...tablefilterLabel2.slice(3)]
    }
    if (showSenderColumns) {
      return insertBeforeReceiver(labels)
    }
    return labels
  }, [isCompanyTwelve, isGujaratCompany, showSenderColumns])
  const hiddenFilterIndexes = isCompanyTwelve
    ? [9, 10, 11, 12, 13, 14]
    : companyTablefilterLabel1.reduce((acc, group, index) => {
        const ids = Array.isArray(group) ? group.map((f) => f.id) : [group.id]
        const hideGst = shouldHideDeliveryGstColumn && ids.includes('GST')
        const hideCharges = shouldHideDeliveryChargeColumns && ['CartageAmount', 'DeliveryChg', 'OperatorHamaliChg', 'DemurrageChg', 'discount', 'Discount'].some((id) => ids.includes(id))
        if (hideGst || hideCharges) acc.push(index)
        return acc
      }, [])
  const visibleTablefilterLabel1 = hiddenFilterIndexes.length ? companyTablefilterLabel1.filter((_, index) => !hiddenFilterIndexes.includes(index)) : companyTablefilterLabel1
  const excelColumnCount = isCompanyTwelve ? 10 : showSenderColumns && shouldHideDeliveryChargeColumns ? 9 : showSenderColumns ? 14 : shouldHideDeliveryChargeColumns ? 9 : 14
  const companyHeadCellStyles = isSamayOrTulsiTravel ? { ...headCellStyles, fontSize: '16px', fontWeight: 600 } : headCellStyles
  const companyCellStyles = isSamayOrTulsiTravel ? { ...cellStyles, fontSize: '16px', fontWeight: 600 } : cellStyles
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()

      const focusableElements = document.querySelectorAll('input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])')
      const currentIndex = Array.from(focusableElements).indexOf(event.target)
      const nextIndex = (currentIndex + 1) % focusableElements.length
      focusableElements[nextIndex].focus()
    }
  }

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      // Clean up the event listener when the component unmounts
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  const exactMatchFilterFields = ['Units']

  const matchesColumnFilter = (columnId, filterValue, value) => {
    if (!filterValue) return true
    if (value == null || value === '') return false

    if (exactMatchFilterFields.includes(columnId)) {
      const numFilter = Number(filterValue)
      const numValue = Number(value)
      if (!Number.isNaN(numFilter) && !Number.isNaN(numValue)) {
        return numFilter === numValue
      }
      return value.toString().toLowerCase() === filterValue.trim().toLowerCase()
    }

    return value.toString().toLowerCase().includes(filterValue.trim().toLowerCase())
  }

  const calculateGrandTotal = (rows) => {
    const defaultRowKeys = ['', '', 'TotalDues', '', '', '', '', 'Units', 'AdditionalDeliveryCartage', 'HomeDeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'DeliveryGST', 'finalAmount']
    const gtRowKeys = ['', '', 'TotalDues', '', '', '', '', '', 'Units', 'AdditionalDeliveryCartage', 'HomeDeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'DeliveryGST', 'finalAmount']
    const senderDefaultRowKeys = ['', '', 'TotalDues', '', '', '', '', '', 'Units', 'AdditionalDeliveryCartage', 'HomeDeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'finalAmount']
    const senderGtRowKeys = ['', '', 'TotalDues', '', '', '', '', '', '', 'Units', 'AdditionalDeliveryCartage', 'HomeDeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'finalAmount']
    const rowKeys = isCompanyTwelve
      ? ['', '', 'TotalDues', '', '', '', '', '', '', 'Units', 'finalAmount']
      : showSenderColumns && shouldHideDeliveryChargeColumns
        ? ['', '', 'TotalDues', '', '', '', '', '', 'Units', 'finalAmount']
        : showSenderColumns
          ? (isGujaratCompany ? senderGtRowKeys : senderDefaultRowKeys)
          : shouldHideDeliveryChargeColumns
            ? ['', '', 'TotalDues', '', '', '', '', 'Units', 'DeliveryGST', 'finalAmount']
            : isGujaratCompany ? gtRowKeys : defaultRowKeys
    const keysToSum = rowKeys.filter(Boolean)
    const grandTotalRow = keysToSum.reduce((acc, key) => {
      const sum = rows.reduce((total, row) => {
        const value = row[key]
        return total + (typeof value === 'number' ? value : 0)
      }, 0)

      acc[key] = sum
      return acc
    }, {})
    return rowKeys.map((key, index) => (index === 1 ? (dm.grandTotal || 'Grand Total') : key ? grandTotalRow[key].toFixed(2) ?? 0 : ''))
  }

  useEffect(() => {
    setfilteredData(tableData)
    const headerRow = headerRef.current;
    const totalRow = totalRowRef.current;

    if (!headerRow || !totalRow || !tableData.length) return
    const syncWidths = () => {
      const headerCells = headerRow.children;
      const totalCells = totalRow.children;

      for (let i = 0; i < headerCells.length; i++) {
        const width = headerCells[i].getBoundingClientRect().width;
        if (totalCells[i]) totalCells[i].style.width = `${width}px`
        else console.log('totalCells[i] not found')
      }
    };
    setTimeout(() => {
      syncWidths();
    }, 300);
    const observer = new MutationObserver(() => {
      syncWidths();
    });
    observer.observe(headerRow, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [isCompanyTwelve, isGujaratCompany, shouldHideDeliveryChargeColumns, showSenderColumns, tableData])

  useEffect(() => {
    if (selectedLRs.length > 0) {
      setexcelData(selectedLRs)
    } else {
      setexcelData(filteredData)
    }
  }, [selectedLRs, filteredData])
  const handleFilterChange = (columnId, value) => {
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [columnId]: value,
    }))
  }
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
      return companyTablefilterLabel2.every((column) => {
        const filterValue = filterValues[column.id] || ''
        const value = item[column.id]
        return matchesColumnFilter(column.id, filterValue, value)
      })
    })
    setfilteredData(rankFilteredRows(filteredDataTemp, filterValues))
  }, [filterValues, tableData, companyTablefilterLabel2])

  useEffect(() => {
    const selectedRows = filteredData.filter((item) => data.checkboxStates?.[item.BookingID])
    const rowsForTotal = selectedRows.length > 0 ? selectedRows : filteredData
    setGrandTotal(calculateGrandTotal(rowsForTotal))
  }, [filteredData, isCompanyTwelve, isGujaratCompany, shouldHideDeliveryChargeColumns, showSenderColumns, data.checkboxStates])

  const updateLrAndSelectedLr = (e, BookingID, updateKey) => {
    const updatedSelectedLrs = updateObjectInArray(selectedLrs, 'BookingID', BookingID, updateKey, e.target.value)
    setSelectedLrs(calculateFinalAmounts(updatedSelectedLrs))
    const updatedTableData = updateObjectInArray(tableData, 'BookingID', BookingID, updateKey, e.target.value)
    setTableData(calculateFinalAmounts(updatedTableData))
  }
  const visibleBookingIds = filteredData.map((item) => item.BookingID)
  const selectedVisibleCount = filteredData.filter((item) => data.checkboxStates?.[item.BookingID]).length
  const showSelectAllCheckbox = filteredData.length > 1
  const areAllVisibleSelected = showSelectAllCheckbox && selectedVisibleCount === filteredData.length
  const areSomeVisibleSelected = selectedVisibleCount > 0 && !areAllVisibleSelected

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = areSomeVisibleSelected
    }
  }, [areSomeVisibleSelected])

  const handleToggleVisibleRows = (e) => {
    const shouldSelect = e.target.checked
    const visibleBookingIdSet = new Set(visibleBookingIds)

    setCheckboxStates((prev) => {
      const next = { ...prev }
      visibleBookingIds.forEach((BookingID) => {
        next[BookingID] = shouldSelect
      })
      return next
    })

    if (shouldSelect) {
      const mergedSelection = [...(selectedLrs || [])]
      filteredData.forEach((item) => {
        if (!mergedSelection.some((selectedItem) => selectedItem.BookingID === item.BookingID)) {
          mergedSelection.push(item)
        }
      })
      setSelectedLrs(mergedSelection)
      return
    }

    setSelectedLrs((selectedLrs || []).filter((item) => !visibleBookingIdSet.has(item.BookingID)))
  }
  const chkBoxNavigation = (e, nextId, prevId) => {
    if (e.key === 'ArrowUp') {
      focusElemnt(prevId)
    }
    if (e.key === 'ArrowDown') {
      focusElemnt(nextId)
      e.preventDefault()
    }
    if (e.key === 'Enter') {
      setTimeout(() => {
        focusElemnt('memoDeliveryReceiver')
      }, 0)
    }
  }
  return (
    <Box style={{ marginLeft: '5px' }}>
      <TableContainer
        className="delivery-memo-table scroll"
        component={Paper}
        sx={{ borderRadius: '8px', border: '1px solid #aeaeae', height: showMore ? 'calc( 50vh - 120px)' : 'calc( 70vh - 100px)', overflow: 'auto', margin: '0px 0px' }}
      >
        <Table aria-label="a dense table" id='del-memo-normal-table' sx={isGujaratCompany ? { tableLayout: 'fixed', width: '100%' } : undefined}>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', background: cs.primary.main, zIndex: 2 }}>
            <TableRow ref={headerRef}>
              <TableCell style={{ ...companyHeadCellStyles, width: isGujaratCompany ? '3%' : '2%', textAlign: 'center', borderTopLeftRadius: '8px' }} />
              {visibleColumnDefsOne
                .map((col, i, arr) => (
                  <TableCell
                    key={`${col.field}-${i}`}
                    style={{
                      ...companyHeadCellStyles,
                      width: getColWidth(col),
                      textAlign: col.textAlign,
                      ...(i === arr.length - 1 ? { borderTopRightRadius: '8px' } : {})
                    }}
                  >
                    {col.headerName.split('\n').map((line, j, lines) => (
                      <React.Fragment key={j}>
                        {line}{j < lines.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                    {/* {col.headerName} */}
                  </TableCell>
                ))
              }
            </TableRow>
            <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
              <TableCell style={{ ...companyCellStyles, textAlign: 'center', width: isGujaratCompany ? '3%' : '2%' }}>
                {showSelectAllCheckbox ? (
                  <Checkbox
                    inputRef={selectAllRef}
                    checked={areAllVisibleSelected}
                    indeterminate={areSomeVisibleSelected}
                    onChange={handleToggleVisibleRows}
                  />
                ) : null}
              </TableCell>
              {visibleTablefilterLabel1.map((filterGroup, index) => (
                <TableCell key={index} style={companyCellStyles}>
                  <Box>
                    {Array.isArray(filterGroup) ? (
                      filterGroup.map((filter, subIndex) => (
                        <FilterInput
                          tabIndex={3}
                          key={subIndex}
                          label={filter.name}
                          marginB={filter.marginB || false}
                          disabled={filter.disabled}
                          value={filterValues[filter.id] || ''}
                          onChange={(e) => handleFilterChange(filter.id, e.target.value)}
                        />
                      ))
                    ) : (
                      <FilterInput
                        tabIndex={3}
                        label={filterGroup.name}
                        marginB={filterGroup.marginB || false}
                        disabled={filterGroup.disabled}
                        value={filterValues[filterGroup.id] || ''}
                        onChange={(e) => handleFilterChange(filterGroup.id, e.target.value)}
                      />
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((el, index) => (
              <DeliveryMemoRow
                key={'table-memo' + index}
                index={index}
                data={el}
                cs={cs}
                selectedTab={selectedTab}
                propData={data}
                methods={methods}
                updateLrAndSelectedLr={updateLrAndSelectedLr}
                chkBoxNavigation={chkBoxNavigation}
                filteredData={filteredData}
                isSamayOrTulsiTravel={isSamayOrTulsiTravel}
                isCompanyTwelve={isCompanyTwelve}
                shouldHideDeliveryChargeColumns={shouldHideDeliveryChargeColumns}
                shouldHideDeliveryGstColumn={shouldHideDeliveryGstColumn}
                showSenderColumns={showSenderColumns}
                isGujaratCompany={isGujaratCompany}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer className="delivery-memo-table scroll" component={Paper} sx={{ height: '40px', overflow: 'auto', margin: '0px 0px' }}>
        <Table aria-label="a dense table" sx={isGujaratCompany ? { tableLayout: 'fixed', width: '100%' } : undefined}>
          <TableBody>
            <TableRow ref={totalRowRef}>
              {grandTotal.map((el, index) => (
                <TableCell key={'total-rs3w' + index} style={{ ...(isSamayOrTulsiTravel ? { ...cellStyles, fontSize: '16px', fontWeight: 600 } : cellStyles), textAlign: 'right', fontWeight: 'bold', height: '42px' }}>
                  {el}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
const DeliveryMemoRow = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const { index, data, cs, selectedTab, propData, methods, updateLrAndSelectedLr, chkBoxNavigation, filteredData, isSamayOrTulsiTravel, isCompanyTwelve, shouldHideDeliveryChargeColumns, shouldHideDeliveryGstColumn, showSenderColumns, isGujaratCompany } = props
  const { selectedLrs, vehicleList, loginData, checkboxStates } = propData
  const { updateSelectedList, updateAlertError } = methods
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const { AllowDemChgChange } = roleRights?.Table1?.[0] || {}
  const isChecked = isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')
  const isFoc = data?.PaymentTypeID === 3
  const isDemurrageEnabledByRights = () => {
    const { IsSTACargoCompany, IsAdmin, IsMTPLAdmin, IsBranchAdmin } = loginData || {}
    if (IsSTACargoCompany && data?.IsDemurrage) {
      if (IsAdmin || IsMTPLAdmin || IsBranchAdmin) return true
    }
    if (![accessNameV2.NOT_ENABLED, accessNameV2.NO_RIGHTS, accessNameV2.LIMITED].includes(AllowDemChgChange)) {
      return true
    }
    if ([accessNameV2.LIMITED, accessNameV2.UNLIMITED].includes(AllowDemChgChange)) {
      return true
    }
    return false
  }
  const {
    bulkDeliveryCheck = false,
    reciverName = '',
    reciverPhone = '',
    getIdProof: receiverIdList = '',
    selectedRecIdType = '',
    ReIdNumber = '',
  } = isChecked ? propData : {}
  const {
    methodOfPayment: MOPList,
    selectedMOP = '',
    partyList,
    selectedParty = '',
    selectedVehicle = '',
    remarks = '',
  } = isChecked ? propData : {}
  const { setRecieverName, setReceiverPhone, setselectedRecIdType, setReIdNumber, setSelectedMOP } = methods
  const { setSelectedParty, setSelectedVehicle, setRemarks, bulkDeliver, setSelectedLrs, onLrClick } = methods
  const isDisabled = bulkDeliveryCheck || !isChecked
  const companyCellStyles = isSamayOrTulsiTravel ? { ...cellStyles, fontSize: '16px', fontWeight: 600 } : cellStyles
  const companyTextStyles = isSamayOrTulsiTravel ? { fontSize: '16px', fontWeight: 600 } : {}
  const [idProof, setIdProof] = useState('')
  const [mop, setMop] = useState('')
  const [party, setParty] = useState('')
  const [vehicle, setVehicle] = useState('')
  useEffect(() => {
    if (selectedRecIdType !== '') {
      setIdProof(selectedRecIdType)
    } else {
      setIdProof(' ')
    }
  }, [selectedRecIdType])
  useEffect(() => {
    if (selectedMOP !== '') {
      setMop(selectedMOP)
    } else {
      setMop(' ')
    }
  }, [selectedMOP])
  useEffect(() => {
    if (selectedParty !== '') {
      setParty(selectedParty)
    } else {
      setParty(' ')
    }
  }, [selectedParty])
  useEffect(() => {
    if (selectedVehicle !== '') {
      setVehicle(selectedVehicle)
    } else {
      setVehicle(' ')
    }
  }, [selectedVehicle])
  const handleIdProofInput = (e, index) => {
    let idValue = e.target.value;
    if (idValue !== '' && selectedRecIdType.IDProof === 'PAN Card') {
      if (pancardValidation(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid PAN Card Number', close: resetValues(), nextId: `idNo-${index}` })
      }
    } else if (idValue !== '' && selectedRecIdType.IDProof === 'Aadhar Card') {
      if (ValidateAadhaar(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid Aadhaar Number', close: resetValues() })
      }
    } else {
      if (idValue !== '') {
        setReIdNumber(idValue)
      }
    }
  }

  const resetValues = () => {
    setReIdNumber('')
    // updateAlertError({ show: false, msg: '' })
    // focusElemnt(`idNo-${index}`)
  }

  return (
    <TableRow>
      <TableCell tabIndex={0} style={{ ...companyCellStyles, textAlign: 'center', width: isGujaratCompany ? '3%' : '2%' }}>
        <Checkbox tabIndex={0} id={'memoTablerowCheck' + index}
          checked={checkboxStates[data.BookingID] || false}
          onChange={(e) => updateSelectedList(e, data, selectedLrs, setSelectedLrs)}
          onKeyDown={(e) => chkBoxNavigation(e, index < filteredData?.length ? `memoTablerowCheck${index + 1}` : 'memoTablerowCheck0', index === 0 ? 'memoExportPdfBtn' : `memoTablerowCheck${index - 1}`)}
        />
      </TableCell>
      <TableCell style={companyCellStyles}>
        <Box>
          <div style={{ padding: 0, color: cs.primary.main, textDecoration: 'underline', cursor: 'pointer', textAlign: 'left' }} onClick={() => onLrClick(data)} >{data?.LRNO}</div>
          <Typography sx={companyTextStyles}>{data?.ManualLRNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={companyCellStyles}>
        <Box>
          <div style={{ ...paymentTypeStyles }}>
            <span
              style={{
                ...companyTextStyles,
                backgroundColor: getPaymentTypeBackground(data?.PaymentType),
                padding: '4px 9px',
                borderRadius: '30px',
                fontWeight: 700,
                textDecoration: data?.PaymentType?.length > 7 ? 'underline' : '',
              }}
              title={data?.PaymentType}
            >
              {data?.PaymentType}
            </span>
          </div>
          <Typography sx={{ ...companyTextStyles, padding: '4px 9px 4px 18px' }}>{data?.TotalDues}</Typography>
        </Box>
      </TableCell>
      {isGujaratCompany && (
        <TableCell style={companyCellStyles}>
          <Typography sx={companyTextStyles}>{data?.DescriptionDet || ''}</Typography>
        </TableCell>
      )}
      <TableCell style={companyCellStyles}>
        <Box>
          <Typography sx={{ ...companyTextStyles, overflow: isGujaratCompany ? 'hidden' : undefined, textOverflow: isGujaratCompany ? 'ellipsis' : undefined, whiteSpace: isGujaratCompany ? 'nowrap' : undefined, width: isGujaratCompany ? '100%' : undefined }}>{data?.SourceCity}</Typography>
          {/* <Tooltip title={data?.SourceBranch} arrow enterTouchDelay={0} placement="top" className={{ tooltip: 'custom-tooltip' }}> */}
          <Typography
            sx={{
              ...companyTextStyles,
              padding: 0,
              display: 'block',
              textOverflow: 'ellipsis',
              textDecoration: data?.SourceBranch?.length > 15 ? 'underline' : '',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: isGujaratCompany ? '100%' : '9vw',
            }}
            title={data?.SourceBranch}
          >
            {data.SourceBranch}
          </Typography>
          {/* </Tooltip> */}
        </Box>
      </TableCell>
      <TableCell style={companyCellStyles}>
        <Box>
          <Typography sx={{ ...companyTextStyles, overflow: isGujaratCompany ? 'hidden' : undefined, textOverflow: isGujaratCompany ? 'ellipsis' : undefined, whiteSpace: isGujaratCompany ? 'nowrap' : undefined, width: isGujaratCompany ? '100%' : undefined }}>{data?.DestinationCity}</Typography>
          {/* <Tooltip title={data?.DestinationBranch} arrow enterTouchDelay={0} placement="top" className={{ tooltip: 'custom-tooltip' }}> */}
          <Typography
            sx={{
              ...companyTextStyles,
              padding: 0,
              display: 'block',
              textOverflow: 'ellipsis',
              textDecoration: data?.DestinationBranch?.length > 15 ? 'underline' : '',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: isGujaratCompany ? '100%' : '9vw',
            }}
            title={data?.DestinationBranch}
          >
            {data.DestinationBranch}
          </Typography>
          {/* </Tooltip> */}
        </Box>
      </TableCell>
      {(isCompanyTwelve || showSenderColumns) && <TableCell style={companyCellStyles}>
        <Box>
          <Typography sx={companyTextStyles}>{data?.Sender}</Typography>
          <Typography sx={companyTextStyles}>{data?.SenderMobileNo}</Typography>
        </Box>
      </TableCell>}
      <TableCell style={companyCellStyles}>
        <Box>
          <Typography sx={companyTextStyles}>{data?.RecName}</Typography>
          <Typography sx={companyTextStyles}>{data?.RecMobileNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={companyCellStyles}>
        <Box>
          <Typography sx={companyTextStyles}>{data.ReceiptDate}</Typography>
          <Typography sx={companyTextStyles}>{data?.ChallanNo}</Typography>
        </Box>
      </TableCell>
      {isCompanyTwelve && <TableCell style={companyCellStyles}>
        <Typography sx={companyTextStyles}>{data?.Consignment}</Typography>
      </TableCell>}
      <TableCell style={companyCellStyles}>
        <Box>
          <Typography className="input--content disabled" sx={companyTextStyles}>{data.Units}</Typography>
          <LineInputV3
            placeholder="Received By"
            value={reciverName}
            onBlur={(e) => setRecieverName(e.target.value)}
            disabled={isDisabled}
          />
        </Box>
      </TableCell>
      {!shouldHideDeliveryChargeColumns && <>      <TableCell style={companyCellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.AdditionalDeliveryCartage || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'AdditionalDeliveryCartage')}

          />
          <LineInputV3
            placeholder="Receiver No."
            value={reciverPhone}
            filter={getInt}
            maxLength={loginData?.MobileNoULimit}
            disabled={isDisabled}
            onBlur={(e) => setReceiverPhone(e.target.value)}
          />
        </Box>
      </TableCell>
        <TableCell style={companyCellStyles}>
          <Box>
            <LineInputV3
              placeholder="0"
              disabled={!isChecked}
              value={data?.HomeDeliveryChg || 0}
              filter={getInt}
              onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'HomeDeliveryChg')}
            />
            <DropDownOA
              label={dm.idProof || 'ID Proof'}
              data={receiverIdList}
              value={idProof?.IDProof || idProof}
              defaultvalue={idProof?.IDProof || idProof}
              idKey={'IDProofid'}
              dataKey={'IDProof'}
              resetFlag={!bulkDeliveryCheck}
              onSelect={(val) => setselectedRecIdType(val)}
              disabled={isDisabled}
              noCross={true}
              listWidth={'200px'}
              onSelResetVal={true}
            />
          </Box>
        </TableCell>
        <TableCell style={companyCellStyles}>
          <Box>
            <LineInputV3
              placeholder="0"
              disabled={!isChecked}
              value={data?.ExtraHamli || 0}
              filter={getInt}
              onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'ExtraHamli')}
            />
            <LineInputV3 id={`idNo-${index}`} placeholder="ID Number" value={ReIdNumber}
              onBlur={(e) => handleIdProofInput(e, index)} disabled={isDisabled} />
          </Box>
        </TableCell>
        <TableCell style={companyCellStyles}>
          <Box>
            <LineInputV3
              placeholder="0"
              disabled={!isChecked || isFoc || !isDemurrageEnabledByRights()}
              value={data?.DemurrageChg || 0}
              filter={getInt}
              onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'DemurrageChg')}
            />
            <DropDownOA
              label={dm.pymtMode || 'Pymt. Mode'}
              value={mop?.ModeName || mop}
              defaultvalue={mop?.ModeName || mop}
              onSelect={(val) => setSelectedMOP(val)}
              data={MOPList}
              idKey={'ModeID'}
              dataKey={'ModeName'}
              resetFlag={!bulkDeliveryCheck}
              disabled={isDisabled || data?.PaymentTypeID === 5 || data?.PaymentTypeID === 10}
              noCross={true}
              listWidth={'200px'}
              onSelResetVal={true}
            />
          </Box>
        </TableCell>
        <TableCell style={companyCellStyles}>
          <Box>
            <LineInputV3
              placeholder="0"
              disabled={!isChecked}
              value={data?.Discount || 0}
              filter={getInt}
              onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'Discount')}
            />
            <DropDownOA
              label={dm.party || 'Party'}
              defaultvalue={party?.Party || party}
              value={party?.Party || party}
              data={partyList}
              dataKey={'Party'}
              idKey={'PartyID'}
              resetFlag={!bulkDeliveryCheck}
              onSelect={(val) => setSelectedParty(val)}
              noCross={true}
              listWidth={'200px'}
              disabled={isDisabled || selectedMOP?.ModeName !== 'Credit'}
              onSelResetVal={true}
            />
          </Box>
        </TableCell></>}
      {!shouldHideDeliveryGstColumn && <TableCell style={companyCellStyles}>
        <Box>
          <LineInputV3 value={data?.DeliveryGST || 0} disabled={true} />
          <DropDownOA
            id="memoDeliveryVehicle"
            nextId="memoDeliveryRemarks"
            prevId="memoDeliveryReceiverParty"
            label={dm.vehNo || 'Veh. No.'}
            data={vehicleList}
            defaultvalue={vehicle?.VehicleNo || vehicle}
            value={vehicle?.VehicleNo || vehicle}
            dataKey={`VehicleNo`}
            idKey={`VehicleID`}
            resetFlag={!bulkDeliveryCheck}
            onSelect={(val) => setSelectedVehicle(val)}
            disabled={isDisabled}
            noCross={true}
            listWidth={'200px'}

          />
        </Box>
      </TableCell>}
      <TableCell style={companyCellStyles}>
        <Box>
          <LineInputV3 value={data?.finalAmount || 0} disabled={true} />
          {/* total amount*/}
          <LineInputV3 placeholder="Remark" value={remarks} disabled={isDisabled} onBlur={(e) => setRemarks(e.target.value)} />
        </Box>
      </TableCell>
    </TableRow>
  )
}
export default DeliveryMemoTable
